import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { AriaDirective } from '../../../shared-components/directives/aria.directive';
import { ExcessiveAttendance, AttendanceSchools, Attendance } from '../../../shared-components/student/attendance.model';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { StudentService } from '../../../shared-components/student/student.service';
import { Student } from '../../../shared-components/student/student.model';
import { YearService } from '../../../shared-components/year/year.service';
import { MatSort } from '@angular/material/sort';
import { CourseSchedule } from '../../../shared-components/student/course-schedule.model';
import { detailExpand } from '../../../shared-components/angular-material/mat-animations';
import { SharedService } from '../../../shared-components/shared.service';
import { Enrollment } from '../../../shared-components/student/enrollment.model';

@Component({
  selector: 'app-by-view-excessive',
  templateUrl: './by-view-excessive.component.html',
  animations: [detailExpand],
})
export class ByViewExcessiveComponent implements OnInit {

  selectedExcessiveAttendanceOption = 0;
  columnsToDisplayExcessiveAttendance = ['Steps', 'Points', 'AppealedStatus'];
  excessiveAttendanceAngularMatData = new TylerMatTableDataSource();
  @Input() selectionIndex: number;
  viewTrackingGroupsOptions: any[] = [];
  studentExcessiveAttendance: ExcessiveAttendance[] = [];
  selectedTrackingGroupOption = 0;
  excessiveAttendanceSchools: AttendanceSchools[] = [];
  selectedStudent: Student;
  viewExcessiveAttendanceOptions: any[] = [];
  @ViewChild(MatSort) sort: MatSort;
  attendance: Attendance[] = [];
  courseSchedules: CourseSchedule[] = [];
  studentEnrollment: Enrollment;
  selected = 'By Date';
  @Input() showAllCodes: boolean;
  isBusy = true;
  @Output() selectedExcessiveAttendanceOptionValueChange = new EventEmitter<number>();
  clearFilterEvent = new EventEmitter<any>();
  constructor(
    private sharedService: SharedService,
    private studentService: StudentService,
    private yearService: YearService,
  ) {
    this.studentEnrollment = this.studentService.studentEnrollment;
  }

  ngOnInit() {
    this.getExcessiveAttendance();
    if (this.selectedExcessiveAttendanceOption == 1) {
      this.columnsToDisplayExcessiveAttendance = ['More', 'Meets', 'Steps', 'Points', 'AppealedStatus'];
    }
    else {
      this.columnsToDisplayExcessiveAttendance = ['Steps', 'Points', 'AppealedStatus'];
    }
  }

  getExcessiveAttendanceAriaRow(row: ExcessiveAttendance): string {
    const colList: string[] = ['Meets', 'Steps', 'Points', 'AppealedStatus'];
    const dataList: string[] = [row.Meets,
    row.Steps.toString(),
    row.Points.toString(),
    row.AppealedStatus
    ];
    return AriaDirective.concatAriaStrings(colList, dataList) + (this.selectedExcessiveAttendanceOption == 1 ? ' Expand for more details' : ' No additional details');
  }

  selectedViewOptionChange() {
    this.expandAll(false);

    if (this.selectedExcessiveAttendanceOption == 1) {
      this.columnsToDisplayExcessiveAttendance = ['More', 'Meets', 'Steps', 'Points', 'AppealedStatus'];
    }
    else {
      this.columnsToDisplayExcessiveAttendance = ['Steps', 'Points', 'AppealedStatus'];
    }

    this.viewTrackingGroupsOptions = [];
    for (const att of this.studentExcessiveAttendance.filter(o => o.TrackingType == this.selectedExcessiveAttendanceOption)) {
      if (this.viewTrackingGroupsOptions.filter(o => o.Value == att.AttendanceStepsDefinitionId).length == 0) {
        const option: any = {
          Value: att.AttendanceStepsDefinitionId,
          Description: att.Description,
          TrackingId: att.TrackingType
        };

        this.viewTrackingGroupsOptions.push(option);
      }
    }
    this.selectedExcessiveAttendanceOptionValueChange.emit(this.selectedExcessiveAttendanceOption);
    if (this.viewTrackingGroupsOptions.length > 0) {
      this.selectedTrackingGroupOption = this.viewTrackingGroupsOptions[0].Value;
    }
  }

  expandAll(expand: boolean) {
    if (this.selectedExcessiveAttendanceOption == 1) {
      this.sharedService.updateShowSpinner(true);
      setTimeout(() => {
        this.excessiveAttendanceAngularMatData.expandAll(expand);
        this.sharedService.updateShowSpinner(false);
      }, 100);
    }
  }

  toggleExpanded(row: any) {
    if (this.selectedExcessiveAttendanceOption == 1) {
      this.excessiveAttendanceAngularMatData.toggleExpanded(row);
    }
  }

  checkExpandedExcessiveAttendance(row: any): boolean {
    return this.excessiveAttendanceAngularMatData.checkExpanded(row);
  }

  rowKeyPress(event: KeyboardEvent, row: any) {
    if (this.selectedExcessiveAttendanceOption == 1) {
      this.excessiveAttendanceAngularMatData.rowKeyPress(event, row);
    }
  }

  getExcessiveAttendance() {
    this.isBusy = true;
    this.studentService.getExcessiveAttendance(this.studentService.selectedStudent.Id, this.yearService.student360Year.Id).subscribe(data => {
      this.studentExcessiveAttendance = data;
      if (this.studentExcessiveAttendance.length > 0) {
        this.getExcessiveAttendanceSchools();
        this.getExcessiveAttendanceSchoolsViewOptions();
        this.excessiveAttendanceAngularMatData = new TylerMatTableDataSource(this.studentExcessiveAttendance);
      }
      else {
        this.isBusy = false;
      }
    });
  }

  getExcessiveAttendanceSchools() {
    for (const att of this.studentExcessiveAttendance) {
      if (this.excessiveAttendanceSchools.filter(o => o.SiteId == att.SiteId).length == 0) {
        const school: AttendanceSchools = {
          SiteId: att.SiteId,
          SiteName: att.SiteName,
          PrimarySchool: att.PrimarySchool
        };
        this.excessiveAttendanceSchools.push(school);
      }
    }
  }

  getExcessiveAttendanceSchoolsViewOptions() {
    if (this.studentExcessiveAttendance.filter(o => o.TrackingType == 0).length > 0) {
      const option: any = {
        Value: 0,
        Description: 'Days'
      };
      this.viewExcessiveAttendanceOptions.push(option);
    }
    if (this.studentExcessiveAttendance.filter(o => o.TrackingType == 1).length > 0) {
      const option: any = {
        Value: 1,
        Description: 'Individual Period'
      };
      this.viewExcessiveAttendanceOptions.push(option);
    }
    if (this.studentExcessiveAttendance.filter(o => o.TrackingType == 2).length > 0) {
      const option: any = {
        Value: 2,
        Description: 'Total Period'
      };
      this.viewExcessiveAttendanceOptions.push(option);
    }

    if (this.viewExcessiveAttendanceOptions.length > 0) {
      this.selectedExcessiveAttendanceOption = this.viewExcessiveAttendanceOptions[0].Value;
      this.selectedViewOptionChange();
    }
  }

  getExcessiveAttendanceDataSource(siteId: number): TylerMatTableDataSource {
    const excessiveAttendance = this.studentExcessiveAttendance.filter(o => o.SiteId == siteId && o.TrackingType == this.selectedExcessiveAttendanceOption && o.AttendanceStepsDefinitionId == this.selectedTrackingGroupOption);
    this.excessiveAttendanceAngularMatData.data = excessiveAttendance;
    this.excessiveAttendanceAngularMatData.sort = this.sort;
    if (this.excessiveAttendanceAngularMatData.data.length > 0) {
      this.isBusy = true;
    }
    else { this.isBusy = false; }
    return this.excessiveAttendanceAngularMatData;
  }

  getStudentAttendanceInfo() {
    if (this.selected == 'By Date') {
      this.studentService.getStudentAttendance(this.studentService.selectedStudent.Id, this.yearService.student360Year.Id, this.showAllCodes).subscribe(data => {
        this.attendance = data;
      });
    }
    else {
      this.studentService.getStudentSchedule(this.studentService.selectedStudent.Id, this.yearService.student360Year.Id, parseInt(this.selected, 10), true, -1, true, false, false, this.showAllCodes).subscribe(data => {
        this.courseSchedules = data;
      });
    }
  }

}
